// @flow
export const DEBUG_TRACING = !__SERVER__ && window.location.search.includes('debug_tracing');
const DEBUG_NO_TRACING = !__SERVER__ && window.location.search.includes('debug_no_tracing');
export const DEBUG_ENABLED = DEBUG_TRACING || DEBUG_NO_TRACING;
export const DISABLE_TRACING = !__SERVER__ && window.location.search.includes('disable_tracing');
